import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=391be68c&scoped=true&"
import script from "./Admin.vue?vue&type=script&lang=ts&"
export * from "./Admin.vue?vue&type=script&lang=ts&"
import style0 from "./Admin.vue?vue&type=style&index=0&id=391be68c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391be68c",
  null
  
)

export default component.exports